import InputIconByKey from '../../../../components/Forms/Input/InputIconByKey';
import { IconKey } from '../../../../types/system/icons';
import { RestaurantMenuCategoryDTO } from '../../../../types/restaurant/RestaurantMenuTypes';
import MenuCategoryActions from './MenuCategoryActions';

interface Props {
  categories: RestaurantMenuCategoryDTO[];
  onEdit: (category: RestaurantMenuCategoryDTO) => void;
  onToggle: (category: RestaurantMenuCategoryDTO) => void;
}

const updatedAt = (value: string) =>
  new Intl.DateTimeFormat('es-SV', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));

const MenuCategoryTable = ({ categories, onEdit, onToggle }: Props) => (
  <div className="hidden overflow-x-auto md:block">
    <table className="w-full min-w-[1050px] table-auto">
      <thead>
        <tr className="border-b border-stroke bg-gray-2/60 text-left text-xs font-semibold uppercase tracking-wide text-bodydark2 dark:border-strokedark dark:bg-meta-4/30">
          <th className="px-4 py-4 text-center">Orden</th>
          <th className="px-4 py-4">Código</th>
          <th className="px-4 py-4">Nombre</th>
          <th className="px-4 py-4">Descripción</th>
          <th className="px-4 py-4">Icono/Color</th>
          <th className="px-4 py-4">Estado</th>
          <th className="px-4 py-4">Fecha de actualización</th>
          <th className="px-4 py-4 text-right">Acciones</th>
        </tr>
      </thead>
      <tbody>
        {categories.map((category) => (
          <tr
            key={category.id}
            className={`border-b border-stroke last:border-0 dark:border-strokedark ${
              category.active ? '' : 'opacity-65'
            }`}
          >
            <td className="px-4 py-4 text-center font-semibold text-black dark:text-white">
              {category.displayOrder}
            </td>
            <td className="whitespace-nowrap px-4 py-4 font-semibold text-primary">
              {category.code}
            </td>
            <td className="px-4 py-4 font-medium text-black dark:text-white">
              {category.name}
            </td>
            <td className="max-w-sm px-4 py-4 text-sm text-bodydark2">
              <span className="line-clamp-2">
                {category.description || 'Sin descripción'}
              </span>
            </td>
            <td className="px-4 py-4">
              <div className="flex items-center gap-2">
                <span
                  className="flex h-8 w-8 items-center justify-center rounded-lg border"
                  style={{
                    backgroundColor: `${category.color || '#3C50E0'}1a`,
                    borderColor: `${category.color || '#3C50E0'}40`,
                    color: category.color || '#3C50E0',
                  }}
                >
                  <InputIconByKey
                    iconKey={(category.icon as IconKey) || 'utensils'}
                    className="h-4 w-4"
                  />
                </span>
                <span className="text-sm text-bodydark2">
                  {category.icon || 'Sin icono'}
                </span>
              </div>
            </td>
            <td className="px-4 py-4">
              <span
                className={`rounded-full border px-2.5 py-1 text-xs font-semibold ${
                  category.active
                    ? 'border-success/20 bg-success/10 text-success'
                    : 'border-danger/20 bg-danger/10 text-danger'
                }`}
              >
                {category.active ? 'Activa' : 'Inactiva'}
              </span>
            </td>
            <td className="whitespace-nowrap px-4 py-4 text-sm text-bodydark2">
              {updatedAt(category.updatedAt)}
            </td>
            <td className="px-4 py-3">
              <MenuCategoryActions
                category={category}
                onEdit={onEdit}
                onToggle={onToggle}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default MenuCategoryTable;
